import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/craft/spotcheck/config',
    name: 'POST_SPOT_ORG',
    method: 'POST',
  });

  return [exec, isRequestSuccessed];
});
